import * as Types from '../actions/Types'

const INITIAL_STATE = {
  currentPost: null,
  isCreating: false,
  isDeletingPostId: null,
  isCommenting: false,
  isLiking: [],
  isDeletingComment: [],
  isDeleting: [],
  toastMessage: ''
}

export default (state = INITIAL_STATE, action) => {
  const { type, payload, loading } = action
  switch (type) {
    case Types.LIKE_POST:
      return {
        ...state,
        isLiking: [state.isLiking, loading]
      }
    case Types.LIKE_POST_SUCCESSFUL:
      return {
        ...state,
        isLiking: state.isLiking.filter(like => like !== loading)
      }
    case Types.LIKE_POST_FAILED:
      return {
        ...state,
        isLiking: state.isLiking.filter(like => like !== loading)
      }
    case Types.DISLIKE_POST:
      return {
        ...state,
        isLiking: [state.isLiking, loading]
      }
    case Types.DISLIKE_POST_SUCCESSFUL:
      return {
        ...state,
        isLiking: state.isLiking.filter(like => like !== loading)
      }
    case Types.DISLIKE_POST_FAILED:
      return {
        ...state,
        isLiking: state.isLiking.filter(like => like !== loading)
      }
    case Types.COMMENT_POST:
      return {
        ...state,
        isCommenting: true
      }
    case Types.COMMENT_POST_SUCCESSFUL:
      return {
        ...state,
        isCommenting: false,
        currentPost: addCommentToCurrentPost(payload, state)
      }
    case Types.COMMENT_POST_FAILED:
      return {
        ...state,
        isCommenting: false
      }
    case Types.SET_POST:
      return {
        ...state,
        currentPost: payload
      }
    case Types.CREATE_NEW_POST:
      return {
        ...state,
        isCreating: true,
        errorCreating: false
      }
    case Types.CREATE_NEW_POST_SUCCESSFUL:
      return {
        ...state,
        isCreating: false,
        errorCreating: false
      }
    case Types.CREATE_NEW_POST_FAILED:
      return {
        ...state,
        isCreating: false,
        errorCreating: true
      }
    case Types.DELETE_POST:
      return {
        ...state,
        isDeleting: [...state.isDeleting, payload]
      }
    case Types.DELETE_POST_SUCCESSFUL:
      return {
        ...state,
        isDeleting: state.isDeleting.filter(id => id !== payload)
      }
    case Types.DELETE_POST_FAILED:
      return {
        ...state,
        isDeleting: state.isDeleting.filter(id => id !== payload)
      }
    case Types.DELETE_COMMENT:
      return {
        ...state,
        isDeletingComment: [...state.isDeletingComment, loading]
      }
    case Types.DELETE_COMMENT_SUCCESSFUL:
      return {
        ...state,
        isDeletingComment: state.isDeletingComment.filter(id => id !== payload),
        currentPost: deleteComment(payload, state)
      }
    case Types.DELETE_COMMENT_FAILED:
      return {
        ...state,
        isDeletingComment: state.isDeletingComment.filter(id => id !== payload)
      }
    case Types.REMOVE_TOAST_MESSAGE:
      return {
        ...state,
        toastMessage: ''
      }
    default:
      return state
  }
}

function addCommentToCurrentPost(payload, state) {
  if (state.currentPost && state.currentPost.id.toString() === payload.postId.toString()) {
    return {
      ...state.currentPost,
      comments: [...state.currentPost.comments, payload]
    }
  }

  return null
}

function deleteComment(payload, state) {
  if (state.currentPost) {
    return {
      ...state.currentPost,
      comments: state.currentPost.comments.filter(
        comment => comment.id.toString() !== payload.commentId.toString()
      )
    }
  }

  return null
}



// WEBPACK FOOTER //
// ./src/reducers/Feed.js